import React, { useContext, useState } from "react";
import PageHeading from "../../Components/PageHeading.js";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import MapBox from "./MapBox";
import MapBoxParliament from "./MapBoxParliament";
import GmsStats from "./GmsStats.js";
import AddNewGrievance from "./AddNewGrievance.js";
import InsightsModal from "./GMSInsights/InsightsModal.js"
import { useNavigate } from "react-router-dom";
import GmsListView from "./GMSListView/index.js";
import { useTranslation } from "react-i18next";

import { Button } from "antd";
import { Popover } from "antd";
import FilterContainer from "../../Components/FilterContainer";
import useAxiosInstance from "../../lib/useAxiosInstance.js";
import { useQuery } from "react-query";

import FilterContent from "./FilterContent";
import useConstituencyData from "../../Components/cdm/hooks/useConstituencyData.js";
import { AppContext } from "../../context/AppContextProvider.js";
import { Bar } from "recharts";
import { BarChart3 } from "lucide-react";
import GMSInsightsView from "./GMSInsightsView/index.js";


const GmsTab = ({ elements }) => {
  const axiosInstance = useAxiosInstance();
  const [isSearch, setIsSearch] = useState(false);
  const [parentId, setParentId] = useState(null);
  const [newGrievanceData, setNewGrievanceData] = useState({});

  const { t } = useTranslation(); // add modal
  const [addGrievanceModal, setAddGrievanceModal] = useState(false);
  const [priorityClick, setPriorityClick] = useState();
  const [statusClick, setStatusClick] = useState();
  const [isInsightsOpen, setIsInsightsOpen] = useState(false);
  const { user } = useContext(AppContext);
  const userData = JSON.parse(localStorage.getItem("user"));
  const showAddModal = () => {
    setAddGrievanceModal(true);
  };
   const { constData, loading } = useConstituencyData(1);

//   const fetchOverviewWidget = async () => {
//   const response = await axiosInstance.get(
//     `/api/widget/getOverview/${user?.organisationId}`
//   );
//   return response.data;
// };

// const overviewWidgetData = useQuery("overview-widgets", fetchOverviewWidget, {
//   enabled: ["data_entry_operator", "office_manager", "cadre"].includes(user.role),
//   retry: 1,
//   refetchOnWindowFocus: false,
// });

// Now update localStorage when hook returns valid data
// if (
//   ["data_entry_operator", "office_manager", "cadre"].includes(user.role) &&
//   overviewWidgetData?.data?.data?.clientUser &&
//   JSON.stringify(user) !== JSON.stringify(overviewWidgetData?.data?.data?.clientUser)
// ) {
//   localStorage.setItem(
//     "user",
//     JSON.stringify({ ...overviewWidgetData?.data?.data?.clientUser, prefix: user.prefix })
//   );
// }

  //Fetch Category List-->
  const fetchCategoryList = async () => {
    const response = await axiosInstance.get(
      `api/category/main?size=${100}&page=${1}&sort=${"DESC"}`
    );
    return response;
  };
  const categoryList = useQuery("Category-List", fetchCategoryList, {
    refetchOnWindowFocus: false,
    retry: 1
  });

  //Fetch Sub-Category List-->
  const fetchSubCategoryList = async (parentId) => {
    const response = await axiosInstance.get(
      `api/category/sub?size=${100}&page=${1}&sort=${"DESC"}&parentId=${parentId}`
    );
    return response;
  };

  const subCategoryList = useQuery(
    ["Sub-Category-List", parentId],
    () => fetchSubCategoryList(parentId),
    { refetchOnWindowFocus: false, retry: 1 }
  );


  // Fetch Office List -->
  const fetchOfficeList = async () => {
    const response = await axiosInstance.get("api/clients/office/info");
    return response;
  };

  const officeList = useQuery("Office-List", fetchOfficeList, {
    refetchOnWindowFocus: false,
    retry: 1,
  });


  // <--
  //populate subcategory data-->
  const handleSubCat = (id) => {
    setParentId(id);
  };

  const renderFilter = () => {
    return (
      <FilterContent
        t={t}
        categoryList={categoryList}
        subCategoryList={subCategoryList}
        newGrievanceData={newGrievanceData}
        parentId={parentId}
        setNewGrievanceData={setNewGrievanceData}
        setParentId={setParentId}
        handleSubCat={handleSubCat}
        officeList={officeList}
      />
    );
  };
  // gms tabs
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState("map");

  const handleTabClick = (tabName) => {
    setActiveTab(tabName);
    navigate(`/gms/${tabName}`);
  };

  const constituencyData = JSON.parse(localStorage.getItem("constituencyData"));

  // console.log("constituencyData",constituencyData)
  const fetchVillagesList = async (constituencyId) => {
    const response = await axiosInstance.get(
      `api/grievances/getVillageNames/${constituencyId}`
    );
    return response;
  };

  const constituencyId = constituencyData?.data._id
  // console.log("constituencyData",constituencyData)
  const villagesList = useQuery(
    ["Villages-List", constituencyId],
    () => fetchVillagesList(constituencyId),
    { refetchOnWindowFocus: false, retry: 1 }
  );

  // console.log("villagesList",villagesList,constituencyId)

  const renderTabContent = () => {
    switch (activeTab) {
      case "list":
        return (
          <GmsListView
            setPriorityClick={setPriorityClick}
            priorityClick={priorityClick}
            statusClick={statusClick}
            setStatusClick={setStatusClick}
            newGrievanceData={newGrievanceData}
            villagesList={villagesList}
          />
        );
      case "map":
        return (
          constituencyData?.data?.type === 'state' ? (<MapBox
            constituencyData={constituencyData}
            villagesList={villagesList}
            setPriorityClick={setPriorityClick}
            priorityClick={priorityClick}
            statusClick={statusClick}
            setStatusClick={setStatusClick}
            newGrievanceData={newGrievanceData}
          />) : (<MapBoxParliament
            constituencyData={constituencyData}
            villagesList={villagesList}
            setPriorityClick={setPriorityClick}
            priorityClick={priorityClick}
            statusClick={statusClick}
            setStatusClick={setStatusClick}
            newGrievanceData={newGrievanceData}
          />)
        );
        case "insights":
          return (
          <GMSInsightsView
            setPriorityClick={setPriorityClick}
            priorityClick={priorityClick}
            statusClick={statusClick}
            setStatusClick={setStatusClick}
            newGrievanceData={newGrievanceData}
            villagesList={villagesList}
          />
        );
      default:
        return (
          // <GmsListView
          //   setPriorityClick={setPriorityClick}
          //   priorityClick={priorityClick}
          //   statusClick={statusClick}
          //   setStatusClick={setStatusClick}
          //   newGrievanceData={newGrievanceData}
          // />
          <MapBox
            constituencyData={constituencyData}
            villagesList={villagesList}
            setPriorityClick={setPriorityClick}
            priorityClick={priorityClick}
            statusClick={statusClick}
            setStatusClick={setStatusClick}
            newGrievanceData={newGrievanceData}
          />
        );
    }
  };

  return (
    <>
      <div className='gms-page-tabs'>
        <ToastContainer />

        <div className="pl-4">
          <PageHeading
          pageTitle={t("gmsPageTitle")}
          pageModalTitle={t("addNewGrievanceModalTitle")}
          pageModalOpen={showAddModal}
          className='mb4'
        />
        </div>
        {/* <div className="page-heading">
          <Button 
            onClick={() => setIsInsightsOpen(true)}
          >
              <BarChart3 size={20} />
              <span>View Insights</span>
          </Button>
        </div> */}

        {userData?.role !== "data_entry_operator" && userData?.role !== "cadre" && (
          <GmsStats
            setPriorityClick={setPriorityClick}
            priorityClick={priorityClick}
            statusClick={statusClick}
            setStatusClick={setStatusClick}
          />
        )}
        <div className='user-table-wrapper mt-5  mr-[1rem]'>
          <div className='tabs-wrapper items-center'>
            <nav className='tms-tabs'>
              <button
                className={activeTab === "map" ? "active" : ""}
                onClick={() => handleTabClick("map")}
              >
                {t("mapView")}
              </button>
              <button
                className={activeTab === "list" ? "active" : ""}
                onClick={() => handleTabClick("list")}
              >
                {t("listView")}
              </button>
              {/* <button
                className={activeTab === "insights" ? "active" : ""}
                onClick={() => handleTabClick("insights")}
              >
                {t("Insights View")}
              </button> */}
            </nav>

            {(activeTab ==='list' || activeTab==='map') && 
              <Popover
                content={renderFilter()}
                trigger='click'
                placement='bottomLeft'
                className='filter-button'
              >
              <Button
                key='add-constituency'
                form='constituency-form'
                type='submit'
                className='search-by'
                style={{
                  width: "auto",
                  color: "var(--primary-color)",
                  border: "1px solid var(--primary-color)"
                }}
              >
                {t("Filter By")}
              </Button>
            </Popover>}
          </div>
          <div className='tms-tab-content'>{renderTabContent()}</div>
        </div>
        {addGrievanceModal && (
          <AddNewGrievance
            villagesList={villagesList}
            addGrievanceModal={addGrievanceModal}
            setAddGrievanceModal={setAddGrievanceModal}
            setActiveTab={setActiveTab}
            userData={userData}
          />
        )}
        <InsightsModal 
          isOpen={isInsightsOpen} 
          onClose={() => setIsInsightsOpen(false)} 
        />
        {isSearch && (
          <FilterContainer isSearch={isSearch} setIsSearchOpen={setIsSearch} />
        )}
      </div>
    </>
  );
};

export default GmsTab;
